module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/global_map_bg_with_news_big.5ea12434.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/global_map_bg_with_news_big.jpg
// module id = 2979
// module chunks = 11